import type { ReportsState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../../AppState';

const selectReports = (state: AppState) => state.reportsPerformance;

export const selectDriversReport = compose(
  (state: ReportsState) => state.driversReportWebData,
  selectReports
);

export const selectVehiclesReport = compose(
  (state: ReportsState) => state.vehiclesReportWebData,
  selectReports
);

export const selectIncidentsReport = compose(
  (state: ReportsState) => state.incidentsReportWebData,
  selectReports
);

export const selectRoutesPointsReport = compose(
  (state: ReportsState) => state.routesPointsReportWebData,
  selectReports
);
